class AnimatedHeroImage {
  constructor(section) {
    this.section = section;
    const media = section.querySelector('.hero__media-wrapper');
    const prev = section.closest('section').previousElementSibling;
    if (!media || !prev) return;

    this.el = media;
    this.prev = prev;
    this.startScale = 1.5;
    this.endScale = 1;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    const rect = this.prev.getBoundingClientRect();
    const sectionRect = this.section.getBoundingClientRect();    const triggerHeight = sectionRect.height * .9;
    const p = Math.min(Math.max(-rect.top, 0), triggerHeight) / triggerHeight;
    const scale = this.startScale + (this.endScale - this.startScale) * p;

    this.el.style.transform = `scale(${scale})`;
  }
}

document.querySelectorAll('.hero_animate_image_section').forEach(section => {
  new AnimatedHeroImage(section);
});
